import { NodeChildAssociationEntry } from '@alfresco/js-api';
import { Action } from '@ngrx/store';

export const START_SESSION = 'START_SESSION';
export const RESUME_SESSION = 'RESUME_SESSION';
export const END_SESSION = 'END_SESSION';
export const END_EDITING = 'END_EDITING';
export const CANCEL_SESSION = 'CANCEL_SESSION';

export class StartSessionOfficeAction implements Action {
  readonly type = START_SESSION;
  constructor(public payload: NodeChildAssociationEntry) {}
}

export class ResumeSessionOfficeAction implements Action {
  readonly type = RESUME_SESSION;
  constructor(public payload: NodeChildAssociationEntry) {}
}

export class EndSessionOfficeAction implements Action {
  readonly type = END_SESSION;
  constructor(
    public payload: {
      node: NodeChildAssociationEntry;
      isMajor: boolean;
      comment?: string;
    }
  ) {}
}

export class EndEditingOfficeAction implements Action {
  readonly type = END_EDITING;
  constructor(public payload: NodeChildAssociationEntry) {}
}

export class CancelSessionOfficeAction implements Action {
  readonly type = CANCEL_SESSION;
  constructor(public payload: NodeChildAssociationEntry) {}
}
